(ns pfo.admin.model (:require
                     [clojure.string :refer [trim replace]]
                     [pfo.api :as api]
                     [pfo.state :as state]
                     [pfo.auth.model :as auth-model]
                     [ajax.json :refer [json-request-format]]
                     [pfo.util :as util :refer [to-value bool-param]]))

(def only-admin-groups auth-model/only-admin-groups)

(defn can-view-family-template-list [compliance? group-id]
  (and
   (auth-model/has-family-perm group-id :can_do_bulk_operations)
   (if compliance?
     (auth-model/has-family-perm group-id :can_add_compliance)
     (auth-model/has-family-perm group-id :can_add_task))))

(defn can-view-any-family-template-list
  ([compliance?]
   (some identity (map #(can-view-family-template-list compliance? %) (keys (auth-model/group-permissions)))))
  ([]
   (or
    (can-view-any-family-template-list true)
    (can-view-any-family-template-list false))))

(defn can-view-template-list [compliance?]
  (if (auth-model/is-user-license-admin)
    true
    (can-view-any-family-template-list compliance?)))

(defn group-admin-permitted-users
  ([{include-contacts       :include-contacts
     regular-only           :regular-only
     include-subcollections :include-subcollections
     exclude-root           :exclude-root
     compliance-assign      :compliance_assign
     task-assign            :task_assign
     :as                    options}
    collection-ids]
   (api/ajaxp
    (str "/groupadmin/permitted_users/?"
         (util/make-params
          {:collection_id            collection-ids
           :include_subcollections   (bool-param include-subcollections)
           :include_contacts         (bool-param include-contacts)
           :exclude_root_collections (bool-param exclude-root)
           :task_assign              (bool-param task-assign)
           :compliance_assign        (bool-param compliance-assign)
           :regular_only             (bool-param regular-only)}))
    {}))
  ([collection-ids] (group-admin-permitted-users collection-ids false)))

(defn subscriber-families-common-permitted-users [{:keys [compliance-assign task-assign]} subscriber-id]
  (api/ajaxp (str "/subscriber/" subscriber-id "/user/")
             {:params
              (util/remove-nil-values {:task_assign              (bool-param task-assign)
                                       :compliance_assign        (bool-param compliance-assign)})}))

(defn group-admin-user-list [active-status order page-number]
  (api/ajaxp (str "/groupadmin/users/") {:params (util/remove-nil-values {:active_status active-status
                                                                          :order order
                                                                          :page page-number})}))

(defn group-admin-user-details [id]
  (api/ajaxp (str "/groupadmin/users/" id "/") {}))

(defn group-admin-user-collection-ids [user-id group-id]
  (api/ajaxp (str "/groupadmin/users/" user-id "/group/" group-id "/permissions/") {}))

(defn group-admin-user-group-access-remove [user-id group-id]
  (api/ajaxp (str "/groupadmin/users/" user-id "/group/" group-id "/")
             {:method :delete}))

(defn group-admin-user-add [form-data]
  (api/ajaxp "/groupadmin/users/"
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-user-update [user-id form-data]
  (api/ajaxp (str "/groupadmin/users/" user-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-user-set-group-perms [user-id group-id form-data]
  (api/ajaxp (str "/groupadmin/users/" user-id "/group/" group-id "/permissions/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-collection-set-perms [collection-id permitted-ids non-permitted-ids]
  (api/ajaxp (str "/groupadmin/collections/" collection-id "/permissions/")
             {:method :post
              :body (util/make-params
                     (util/remove-nil-values {:permitted_user_id (not-empty permitted-ids)
                                              :non_permitted_user_id (not-empty non-permitted-ids)}))}))

(defn group-admin-contact-user-list [group-id]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/contacts/") {}))

(defn group-admin-contact-user-add [group-id form-data]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/contacts/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-contact-user-update [user-id form-data]
  (api/ajaxp (str "/groupadmin/contacts/" user-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-contact-user-delete [user-id]
  (api/ajaxp (str "/groupadmin/contacts/" user-id "/") {:method :delete}))

(defn group-admin-contact-user-details [id]
  (api/ajaxp (str "/groupadmin/contacts/" id "/") {}))

(defn group-admin-groups []
  (api/ajaxp (str "/groupadmin/groups/") {}))

(defn group-admin-managed-user-groups [user-id]
  (api/ajaxp (str "/groupadmin/users/" user-id "/groups/") {}))

(defn group-admin-descendants [parent-id include-self]
  (api/ajaxp (str "/groupadmin/descendants/")
             {:params {:parent_id parent-id
                       :include_self (if include-self "yes" "no")}}))

(defn group-admin-demo-status-list [group-id hide-spinner]
  (api/ajaxp "/groupadmin/demo/list/" {:params {:group_id group-id}
                                       :disable-loadin-counter hide-spinner}))

(defn license-admin-demo-delete [group-id instance-uid]
  (api/ajaxp (str "/licenseadmin/demo/?" (util/make-params {:group_id group-id
                                                            :instance_uid instance-uid}))
             {:method :delete}))

(defn license-admin-demo-status-list [group-id hide-spinner]
  (api/ajaxp "/licenseadmin/demo/list/" {:params {:group_id group-id}
                                         :disable-loadin-counter hide-spinner}))

(defn license-admin-demo-request [group-id aname freeze-time expiration-time image-set]
  (api/ajaxp (str "/licenseadmin/demo/")
             {:method :post
              :params (util/remove-nil-values
                       {:group_id group-id
                        :name aname
                        :freeze_time freeze-time
                        :expiration_time expiration-time
                        :image_set image-set})}))


(defn group-admin-invitations-user [email]
  (api/ajaxp "/groupadmin/invitations/user/" {:params {:email email}}))

; TODO invite-existing-user
(defn group-admin-invite-user [email group-ids]
  (api/ajaxp "/groupadmin/invitations/user/" {:method :post
                                              :body (util/make-params (util/remove-nil-values
                                                                       {:email email :group_id group-ids}))}))

(defn group-admin-invitation-list [group-id]
  (api/ajaxp "/groupadmin/invitations/" {:params (util/remove-nil-values {:group_id group-id})}))

(defn group-admin-invitation-list-cancel [uid]
  (api/ajaxp (str "/groupadmin/invitations/cancel/" uid "/") {:method :post}))

(defn group-admin-invitation-list-resend [uid]
  (api/ajaxp (str "/groupadmin/invitations/resend/" uid "/") {:method :post}))

(defn license-admin-user-list [active-status order page-number family-id]
  (api/ajaxp (str "/user/") {:params (util/remove-nil-values {:active_status active-status
                                                              :order order
                                                              :page page-number
                                                              :family_id family-id})}))

(defn license-admin-user-details [id]
  (api/ajaxp (str "/licenseadmin/users/" id "/") {}))

(defn license-admin-user-add [form-data]
  (api/ajaxp "/licenseadmin/users/"
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-user-update [user-id form-data]
  (api/ajaxp (str "/licenseadmin/users/" user-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-groups []
  (api/ajaxp (str "/licenseadmin/groups/") {}))

(defn license-admin-group-details [id]
  (api/ajaxp (str "/licenseadmin/group/" id "/") {}))

(defn group-admin-collection-add [form-data]
  (api/ajaxp (str "/groupadmin/collections/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-collection-update [collection-id form-data]
  (api/ajaxp (str "/groupadmin/collections/" collection-id "/")
             {:method :post
              :format (json-request-format)
              :params (util/remove-nil-values form-data)}))

(defn group-admin-collection-details-update [collection-id form-data]
  (api/ajaxp (str "/groupadmin/collection-details/" collection-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-collection-data-update [collection-id form-data]
  (api/ajaxp (str "/groupadmin/collection-data/" collection-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-collection-delete [id]
  (api/ajaxp (str "/groupadmin/collections/" id "/")
             {:method :delete}))

(defn group-admin-categories [group-id order]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/categories/") {}))

(defn group-admin-category-details [category-id]
  (api/ajaxp (str "/groupadmin/categories/" category-id "/") {}))

(defn templategroups [subscriber-id group-id atype order show-hidden filter-active]
  (api/ajaxp (str "/templategroup/")
             {:params (util/remove-nil-values
                       (merge
                        {:subscriber_id subscriber-id
                         :group_id      group-id
                         :type          atype
                         :order         order,
                         :filter_active filter-active}
                        (when show-hidden {:show_hidden "yes"})))}))

(defn templategroup-get [id]
  (api/ajaxp (str "/templategroup/" id "/") {}))

(defn templategroup-add [form-data]
  (api/ajaxp (str "/templategroup/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn templategroup-update [group-id form-data]
  (api/ajaxp (str "/templategroup/" group-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn templategroup-delete [group-id]
  (api/ajaxp (str "/templategroup/" group-id "/")
             {:method :delete}))

(defn template-add [form-data]
  (api/ajaxp (str "/template/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn template-update [template-id form-data]
  (api/ajaxp (str "/template/" template-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn template-delete [template-id]
  (api/ajaxp (str "/template/" template-id "/")
             {:method :delete}))

(defn copy-template [template-id subscriber-id group-id hide-original]
  (api/ajaxp (str "/copy/templategroups/" template-id "/")
             {:method :post
              :body   (util/make-params
                       (util/remove-nil-values
                        {:subscriber_id subscriber-id :group_id group-id :hide_original hide-original}))}))

(defn templategroupdeleted-add [form-data]
  (api/ajaxp (str "/templategroupdeleted/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn templategroupdeleted-delete [template-group-deleted-id]
  (api/ajaxp (str "/templategroupdeleted/" template-group-deleted-id "/")
             {:method :delete}))

(defn templateuser-list [template-ids subscriber-id group-id]
  (api/ajaxp (str "/templateuser/?"
                  (util/make-params
                   (util/remove-nil-values
                    {:template_id template-ids
                     :subscriber_id subscriber-id
                     :group_id group-id}))) {}))

(defn templateuser-set [template-id subscriber-id group-id user-id]
  (api/ajaxp "/templateuser/"
             {:method :post
              :params (util/remove-nil-values
                       {:template_id template-id
                        :subscriber_id subscriber-id
                        :group_id group-id
                        :user_id user-id})}))

(defn group-admin-template-add [group-id task-template-group-id form-data]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/templategroup/" task-template-group-id "/templates/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-template-update [group-id id form-data]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/templates/" id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-template-delete [group-id id]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/templates/" id "/")
             {:method :delete}))

(defn group-admin-asset-types [group-id]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/assettypes/") {}))

(defn group-admin-asset-type [id]
  (api/ajaxp (str "/groupadmin/assettypes/" id "/") {}))

(defn group-admin-asset-type-add [group-id form-data]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/assettypes/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-asset-type-update [group-id id form-data]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/assettypes/" id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-asset-type-delete [group-id id]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/assettypes/" id "/")
             {:method :delete}))

(defn group-admin-collection-types [group-id asset-type-id]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/assettypes/" asset-type-id "/collectiontypes/") {}))

(defn group-admin-collection-type [id]
  (api/ajaxp (str "/groupadmin/collection-types/" id "/") {}))

(defn group-admin-collection-type-add [group-id form-data]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/collectiontypes/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-collection-type-update [group-id id form-data]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/collectiontypes/" id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-collection-type-delete [group-id id]
  (api/ajaxp (str "/groupadmin/groups/" group-id "/collectiontypes/" id "/")
             {:method :delete}))

(defn license-admin-asset-types []
  (api/ajaxp (str "/licenseadmin/assettypes/") {}))

(defn license-admin-asset-type [id]
  (api/ajaxp (str "/licenseadmin/assettypes/" id "/") {}))

(defn license-admin-asset-type-add [form-data]
  (api/ajaxp (str "/licenseadmin/assettypes/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-asset-type-update [id form-data]
  (api/ajaxp (str "/licenseadmin/assettypes/" id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-asset-type-delete [id]
  (api/ajaxp (str "/licenseadmin/assettypes/" id "/")
             {:method :delete}))

(defn license-admin-collection-types [asset-type-id]
  (api/ajaxp (str "/licenseadmin/assettypes/" asset-type-id "/collectiontypes/") {}))

(defn license-admin-collection-type [id]
  (api/ajaxp (str "/licenseadmin/collection-types/" id "/") {}))

(defn license-admin-collection-type-add [form-data]
  (api/ajaxp (str "/licenseadmin/collectiontypes/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-collection-type-update [id form-data]
  (api/ajaxp (str "/licenseadmin/collectiontypes/" id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-collection-type-delete [id]
  (api/ajaxp (str "/licenseadmin/collectiontypes/" id "/")
             {:method :delete}))

(defn license-admin-group-add [form-data]
  (api/ajaxp (str "/licenseadmin/groups/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-group-update [group-id form-data]
  (api/ajaxp (str "/licenseadmin/group/" group-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-templategroups [atype order]
  (api/ajaxp (str "/licenseadmin/templategroups/") {:params {:type atype
                                                             :order order}}))

(defn license-admin-templategroup [id]
  (api/ajaxp (str "/licenseadmin/templategroups/" id "/") {}))

(defn license-admin-templategroup-add [form-data]
  (api/ajaxp (str "/licenseadmin/templategroups/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-templategroup-update [id form-data]
  (api/ajaxp (str "/licenseadmin/templategroups/" id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-templategroup-delete [id]
  (api/ajaxp (str "/licenseadmin/templategroups/" id "/")
             {:method :delete}))

(defn license-admin-template-add [form-data]
  (api/ajaxp (str "/licenseadmin/templates/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-category-details [category-id]
  (api/ajaxp (str "/licenseadmin/categories/" category-id "/") {}))

(defn license-admin-delete-categories [category-id]
  (api/ajaxp (str "/licenseadmin/categories/" category-id "/")
             {:method :delete
              :response :raw}))

(defn license-admin-category-update [category-id form-data]
  (api/ajaxp (str "/licenseadmin/categories/" category-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-category-add [form-data]
  (api/ajaxp (str "/licenseadmin/categories/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-template-update [id form-data]
  (api/ajaxp (str "/licenseadmin/templates/" id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-template-delete [id]
  (api/ajaxp (str "/licenseadmin/templates/" id "/")
             {:method :delete}))

(defn license-admin-send-registration-confirmation [user-id]
  (api/ajaxp (str "/licenseadmin/users/" user-id "/confirmation/")
             {:method :post}))

(defn license-admin-subscribers [active group-id]
  (api/ajaxp
   (str "/subscriber/?"
        (util/make-params
         (util/remove-nil-values
          (merge (when active {:active "yes"}) {:group_id group-id}))))
   {}))

(defn license-admin-subscriber-details [subscriber-id]
  (api/ajaxp (str "/licenseadmin/subscribers/details/" subscriber-id "/") {}))

(defn license-admin-subscriber-add [form-data]
  (api/ajaxp (str "/licenseadmin/subscribers/add/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn license-admin-subscriber-update [subscriber-id form-data]
  (api/ajaxp (str "/licenseadmin/subscribers/update/" subscriber-id "/")
             {:method :post
              :body (util/make-params (util/remove-nil-values form-data))}))

(defn group-admin-send-registration-confirmation [user-id]
  (api/ajaxp (str "/groupadmin/users/" user-id "/confirmation/")
             {:method :post}))

(defn group-admin-bulk-edits [group-id]
  (api/ajaxp (str "/groupadmin/bulkedits/") {:params {:group_id group-id}}))

(defn group-admin-bulk-operations [group-id]
  (api/ajaxp (str "/bulk/operations/") {:params {:group_id group-id}}))

(defn group-admin-bulk-operation [group-id operation-id]
  (api/ajaxp (str "/bulk/operation/") {:params {:group_id group-id
                                                :id operation-id}}))

(defn group-admin-bulk-edit-items [bulk-edit-id page-number]
  (api/ajaxp (str "/groupadmin/bulkedits/" bulk-edit-id "/items/")
             {:params {:page page-number}}))

(defn group-admin-bulk-apply-items [group-id operation-id page-number]
  (api/ajaxp (str "/bulk/apply/items/")
             {:params {:page page-number
                       :group_id group-id
                       :id operation-id}}))

(defn group-admin-nominate [group-id user-id]
  (api/ajaxp (str "/groupadmin/nominate/" group-id "/" user-id "/") {:method :post}))

(defn group-admin-nomination [group-id user-id]
  (api/ajaxp (str "/groupadmin/nomination/" group-id "/" user-id "/") {}))

(defn license-admin-nomination-handle [nomination-id status]
  (api/ajaxp (str "/licenseadmin/nomination/" nomination-id "/handle/") {:method :post
                                                                         :params {:status status}}))

(defn license-admin-nominations [status page-number]
  (api/ajaxp "/licenseadmin/nominations/" {:params (util/remove-nil-values {:page page-number
                                                                            :status status})}))

(defn subscribers [admin-only]
  (api/ajaxp
   (str "/subscriber/?"
        (util/make-params
         (util/remove-nil-values
          (when admin-only {:admin "yes"}))))
   {}))


(defn subscriber [id]
  (api/ajaxp (str "/subscriber/" id "/") {}))

(defn subscriber-name [subscriber]
  [:span (when-not (:active subscriber) {:class :u-strikethrough}) (:name subscriber)])

(defn can-templategroup-be-hidden [tg]
  (or (some? (:subscriber_id tg))
      (and (nil? (:subscriber_id tg)) (nil? (:collection_id tg)))))

(defn license-admin-families-for-subscriber [subscriber-id]
  (api/ajaxp (str "/subscriber/" subscriber-id "/family/") {}))

(defn automation-transaction-list [family-id page-number order]
  (api/ajaxp "/automation/transaction/"
             {:params (util/remove-nil-values {:family_id family-id
                                               :page page-number
                                               :order order})}))

(defn automation-transaction-document-list [transaction-id page-number order]
  (api/ajaxp (str "/automation/transaction/" transaction-id "/item/")
             {:params (util/remove-nil-values {:page page-number
                                               :order order})}))

(defn automation-disposition-list [family-id page-number order include-related-objects assignments uid collection-name label-ids]
  (api/ajaxp "/automation/disposition/"
             {:params (util/remove-nil-values {:family_id family-id
                                               :page page-number
                                               :order order
                                               :include_related_objects include-related-objects
                                               :assignments assignments
                                               :disposition_uid uid
                                               :collection_name collection-name
                                               :label_id label-ids})}))

(defn disposition [disposition-id]
  (api/ajaxp (str "/automation/disposition/" disposition-id "/") {}))

(defn disposition-add [family-id disposition]
  (api/ajaxp (str "/automation/disposition/")
             {:method :post
              :params (util/remove-nil-values {:disposition_uid (:uid disposition)
                                               :description (:description disposition)
                                               :family_id family-id
                                               :label_id (:label-id disposition)
                                               :label_name_new (:label-name-new disposition)})}))

(defn disposition-update [disposition-id disposition]
  (api/ajaxp (str "/automation/disposition/" disposition-id "/")
             {:method :post
              :params (util/remove-nil-values {:disposition_uid (:uid disposition)
                                               :description (:description disposition)
                                               :label_id (:label-id disposition)
                                               :label_name_new (:label-name-new disposition)
                                               :clear_objects false})}))

(defn disposition-clear-objects [disposition]
  (api/ajaxp (str "/automation/disposition/" (:id disposition) "/")
             {:method :post
              :params (util/remove-nil-values  {:disposition_uid (:uid disposition)
                                                :family_id (:family_id disposition)
                                                :clear_objects true})}))
(defn disposition-delete [disposition-id]
  (api/ajaxp (str "/automation/disposition/" disposition-id "/") {:method :delete}))

(def transaction-state-open "o")
(def transaction-state-closed "c")
(def transaction-state-rolled-back "r")

(def transaction-state-name
  {transaction-state-open "open"
   transaction-state-closed "closed"
   transaction-state-rolled-back "rolled back"})


(defn transaction-rollback [tx-id]
  (api/ajaxp (str "/automation/transaction/" tx-id "")
             {:method :post
              :params {:state "r"}}))


(def transaction-document-status-failure "f")
(def transaction-document-status-success "s")

(def transaction-document-status-name
  {transaction-document-status-failure "failure"
   transaction-document-status-success "success"})

(def transaction-document-error-other 1)
(def transaction-document-error-not-unique 2)

(defn collection-template-list []
  (api/ajaxp "/collection_template/" {}))

(defn us-states []
  (api/ajaxp "/us_states/" {}))

(defn countries [scope]
  (api/ajaxp "/countries/"
             {:method :post
              :params {:scope scope}}))

(def country-scope-all "all")
(def country-scope-us-territory "us_territory")
(def country-scope-us "us")
(def country-scope-foreign "foreign")

(def it-type-drivers-license "drivers_license")
(def id-type-state-local-tribe "state_local_tribe_id")
(def id-type-passport "passport")
(def id-type-foreign-passport "foreign_passport")

(defn country-scope-by-id-type [id-type]
  (condp = id-type
    it-type-drivers-license country-scope-us-territory
    id-type-state-local-tribe country-scope-us-territory
    id-type-passport country-scope-us
    id-type-foreign-passport country-scope-foreign
    country-scope-all))

(def object-type-task-template-group "ttg")
(def object-type-disposition "disp")

(def one-day "1_day")
(def one-week "1_week")
(def thirty-days "30_days")
(def ninety-days "90_days")
(def six-months "6_months")
(def one-year "1_year")

(def time-range-choices
  [[one-day "One day"]
   [one-week "One week"]
   [thirty-days "30 days"]
   [ninety-days "90 days"]
   [six-months "6 months"]
   [one-year "One year"]])


